(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-legal-guarantee"] && !Shopify.designMode) return;
  try {
    (() => {
      const dialog = document.getElementById('EuLegalGuaranteeDialog');
      if (!dialog || dialog.dataset.initialized === 'true') return;

      dialog.dataset.initialized = 'true';
      let activeTrigger = null;

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-eu-guarantee-open]');
        if (!trigger) return;

        activeTrigger = trigger;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });

      dialog.querySelector('[data-eu-guarantee-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => activeTrigger?.focus());
    })();
  } catch(e) { console.error(e); }
})();

})();
